// The URL state of an object's list (`/o/:object?view&d&q&from`): the route validates it with this schema, and the
// list screens read it back through it (a screen shown under another route, like "New", sees that route's search).
import { useSearch } from '@tanstack/react-router';
import { useMemo } from 'react';
import { z } from 'zod';
import { DRAFT_MAX_LENGTH } from './grid/draft-limit';

export const ListSearch = z.object({
  /** The saved view, by key or id. */
  view: z.string().max(100).optional().catch(undefined),
  // The draft is validated when it is read (an invalid one is ignored, never an error page).
  d: z.string().max(DRAFT_MAX_LENGTH).optional().catch(undefined),
  q: z.string().max(200).optional().catch(undefined),
  /** The record a link to this list came from: its filter is a lens named after it, not an edit of the view. */
  from: z.string().max(300).optional().catch(undefined),
});
export type ListSearch = z.infer<typeof ListSearch>;

/** The list search of the route on screen: what the route validated, or (under another route) what fits. */
export function useListSearch(): ListSearch {
  const raw: unknown = useSearch({ strict: false });
  return useMemo(() => ListSearch.safeParse(raw).data ?? {}, [raw]);
}
